/* eslint-disable */
const addObserver = (observedElement, activeClass, removeClassOutside, options) => {
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                options.callback ? options.callback(observedElement) : entry.target.classList.add(activeClass);
                if (!removeClassOutside) {
                    observer.unobserve(entry.target);
                }
            } else {
                entry.target.classList.remove(activeClass);
            }
        });
    }, options);
    observer.observe(observedElement);
};

/**
 * Add active class when element is in viewport
 *
 * @param {string} observedSelector proper css selector that should be observed
 * @param {string} activeClass proper css class that should be added when the element is in viewport
 * @param {boolean} removeClassOutside remove active class when item is outside viewport. Default `false`
 * @param {{}} options for options see https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
 *
 * @returns {void}
 */
export const addInViewportClass = (observedSelector, activeClass, removeClassOutside = false, options = {}) => {
    const observedElements = document.querySelectorAll(observedSelector);

    observedElements.forEach((observedElement) => {
        addObserver(observedElement, activeClass, removeClassOutside, options);
    });
};
/* eslint-enable */
